// Rotas da seção IA, visível apenas para administradores (ver AI.md).
import { frontendURL } from '../../../helper/URLHelper';
import AiDocumentsPage from './pages/AiDocumentsPage.vue';
import AiSettingsPage from './pages/AiSettingsPage.vue';
import AiSandboxPage from './pages/AiSandboxPage.vue';

const meta = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai/documents'),
    name: 'ai_documents_index',
    component: AiDocumentsPage,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/ai/settings'),
    name: 'ai_settings_index',
    component: AiSettingsPage,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/ai/sandbox'),
    name: 'ai_sandbox_index',
    component: AiSandboxPage,
    meta,
  },
];
